// Attachment types and constants for file attachments

export interface Attachment {
  id: string;
  user_id: string;
  session_id: string;
  filename: string;
  media_type: string;
  size_bytes: number;
  r2_key: string;
  has_extracted_text: number; // D1 SQLite boolean (0/1)
  created_at: string;
  deleted_at: string | null;
}

export interface AttachmentResponse {
  id: string;
  filename: string;
  media_type: string;
  size_bytes: number;
  created_at: string;
  url?: string;           // reference URL for images (/api/attachments/:id/image)
  extractedText?: string; // extracted text for documents
}

export const ALLOWED_DOCUMENT_TYPES = new Set([
  "text/plain",
  "text/markdown",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]);

export const ALLOWED_IMAGE_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "image/webp",
]);

export const ALL_ALLOWED_TYPES = new Set([
  ...ALLOWED_DOCUMENT_TYPES,
  ...ALLOWED_IMAGE_TYPES,
]);

export function isImageType(mediaType: string): boolean {
  return ALLOWED_IMAGE_TYPES.has(mediaType);
}

export function isDocumentType(mediaType: string): boolean {
  return ALLOWED_DOCUMENT_TYPES.has(mediaType);
}

export const MAX_FILE_SIZE = 10 * 1024 * 1024;       // 10MB
export const MAX_EXTRACTED_TEXT = 100 * 1024;          // 100KB
